import React, { useCallback, useMemo } from 'react';
import { SignatureDrawer } from './signature-drawer';
import { classes } from './signature.st.css';
import { useAsyncValue } from '../../contexts/field-async-value';
import { useUploadSignature } from './use-upload-signature';
import { isDataUrl, processDataUrl } from './utils/data-url';
import { SignatureFooter } from './signature-footer';
import { useTemporaryValue } from '../../contexts/field-temporary-value-context';
import { useTpaStyleParams } from '../shared/use-tpa-style-params';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import classNames from 'classnames';
export function SignatureUI(_ref) {
  let {
    target,
    inputId,
    ariaDescribedBy,
    ariaLabelledBy,
    enableUpload,
    buttonText,
    onChange,
    onBlur,
    value,
    hasError
  } = _ref;
  const uploadSignatureFile = useUploadSignature();
  const {
    inputBackgroundColor,
    inputTheme,
    inputValueColor,
    isBorderStyleNone
  } = useTpaStyleParams();
  const [temporaryFile, setTemporaryFile] = useTemporaryValue(target);
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const uploadSignature = useCallback(async () => {
    const dataUrl = value == null ? void 0 : value[0].url;
    if (isDataUrl(dataUrl)) {
      const signatureFile = await processDataUrl(dataUrl, inputBackgroundColor);
      if (signatureFile) {
        const uploadedValue = await uploadSignatureFile(signatureFile);
        return [uploadedValue];
      } else {
        // The signature is empty ( example the user choose a fully transparent image )
        setTemporaryFile(undefined);
        return null;
      }
    }
    return value;
  }, [inputBackgroundColor, setTemporaryFile, uploadSignatureFile, value]);
  const signatureDrawerOptions = useMemo(() => ({
    throttle: 0,
    dotSize: 2,
    minWidth: 1,
    maxWidth: 3,
    velocityFilterWeight: 0.2,
    backgroundColor: inputBackgroundColor,
    penColor: inputValueColor
  }), [inputBackgroundColor, inputValueColor]);
  useAsyncValue(target, uploadSignature);
  const handleChange = useCallback(newSignature => {
    if (newSignature) {
      onChange == null || onChange([newSignature]);
      setTemporaryFile([newSignature]);
    } else {
      onChange == null || onChange(null);
      setTemporaryFile(undefined);
    }
  }, [onChange, setTemporaryFile]);
  const signature = temporaryFile ? temporaryFile[0] : value == null ? void 0 : value[0];
  return /*#__PURE__*/React.createElement("div", {
    id: inputId,
    className: classes.root,
    "aria-labelledby": ariaLabelledBy,
    "aria-describedby": ariaDescribedBy,
    onBlur: onBlur
  }, /*#__PURE__*/React.createElement(SignatureDrawer, {
    onChange: handleChange,
    className: classNames(classes.drawer, {
      [classes.error]: hasError,
      [classes.noBorder]: isBorderStyleNone,
      [classes.hover]: forcedHover
    }),
    options: signatureDrawerOptions,
    value: signature,
    theme: inputTheme
  }), /*#__PURE__*/React.createElement(SignatureFooter, {
    value: signature,
    buttonText: buttonText,
    enableUpload: enableUpload,
    onChange: handleChange
  }));
}
//# sourceMappingURL=signature.js.map